import { ColumnsType } from "antd/es/table";
import { SPFileSystemItem } from "../../../api/BoardVue";
import { FileExplorerColumns } from "../../../components/FileExplorer/FileExplorerList";
import { dateValidation } from "../../../helpers/dateValidation";
import { Flex } from "antd";
import { FolderFilled, FileTextOutlined } from '@ant-design/icons'
import { BoolSort, DateSort, FileNaturalCompare, TextSort } from "../../../helpers/SorterHelper";

const columns: ColumnsType<SPFileSystemItem> = [
    {
        key: "1",
        colSpan: 0,
        width: "5%",
        dataIndex: "isFolder",
        render: (isFolder: any) => (
            <Flex align="center" justify="center">
                {isFolder ? <FolderFilled style={{ fontSize: 20, color: "#5B7B94" }} /> : <FileTextOutlined style={{ fontSize: 20, color: "#5B7B94" }} />}
            </Flex>
        )
    },
    {
        key: "2",
        title: "Name",
        colSpan: 2,
        align: 'left',
        width: "50%",
        dataIndex: "localName",
        sorter: (a: SPFileSystemItem, b: SPFileSystemItem) => FileNaturalCompare(a.localName, b.localName, 'ascend', a.isFolder, b.isFolder),
        defaultSortOrder: 'ascend',
        render: (text: any) => <div className="wrap-text-anywhere">{text}</div>,
    },
    // {
    //     key: "3",
    //     title: "Type",
    //     width: "7%",
    //     dataIndex: "isFolder",
    //     render: (isFolder: any) => (isFolder ? "Folder" : "File"),
    //     sorter: (a: SPFileSystemItem, b: SPFileSystemItem) => BoolSort(a,b,"isFolder"),
    // },
    {
        key: "4",
        title: "Modified",
        width: "8%",
        dataIndex: "modified",
        sorter: (a: SPFileSystemItem, b: SPFileSystemItem) => DateSort(a, b, "modified"),
        render: (date: any) => dateValidation(date),
    },
    {
        key: "5",
        title: "Modified By",
        width: "25%",
        dataIndex: "modifiedByName",
        sorter: (a: SPFileSystemItem, b: SPFileSystemItem) => TextSort(a,b,"modifiedByName"),
    },
];

const small: ColumnsType<SPFileSystemItem> = [
    {
        key: "1",
        colSpan: 0,
        width: "5%",
        dataIndex: "isFolder",
        render: (isFolder: any) => (
            <Flex align="center" justify="center">
                {isFolder ? <FolderFilled style={{ fontSize: 20, color: "#5B7B94" }} /> : <FileTextOutlined style={{ fontSize: 20, color: "#5B7B94" }} />}
            </Flex>
        )
    },
    {
        key: "2",
        colSpan: 2,
        align: 'left',
        title: "Name",
        dataIndex: "localName",
        sorter: ((a: SPFileSystemItem, b: SPFileSystemItem, direction: string) => FileNaturalCompare(a.localName, b.localName, direction, a.isFolder, b.isFolder)) as any,
        defaultSortOrder: 'ascend',
        render: (text: any) => <div className="wrap-text-anywhere">{text}</div>
    },
    {
        key: "3",
        width: "8%",
        title: "Modified",
        dataIndex: "modified",
        sorter: (a: SPFileSystemItem, b: SPFileSystemItem) => DateSort(a,b,"modified"),
        render: (date: any) => dateValidation(date)
    },
    {
        key: "4",
        width: "37%",
        title: "Modified By",
        dataIndex: "modifiedByName",
        sorter: (a: SPFileSystemItem, b: SPFileSystemItem) => TextSort(a,b,"modifiedByName")
    }
];

const BoardDocumentsColumns: FileExplorerColumns<SPFileSystemItem> = {
    large: columns,
    small: small,
};

export default BoardDocumentsColumns;